import { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { Navigate, useLocation } from "react-router-dom";

export default function MembershipIndexPage() {
  const location = useLocation();
  const base = location.pathname.replace(/\/$/, "");
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const showProspectProgramTab = flagsLoaded && flags["backoffice-prospect-program-tab"] !== true;

  const canViewPersonMembership = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonMembership
  });
  const canManageApplications = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.manageApplications
  });

  const firstTab = [
    canViewPersonMembership && "overview",
    canViewPersonMembership && "path-to-membership",
    canViewPersonMembership && showProspectProgramTab && "prospect-program",
    canManageApplications && "applications",
    "section",
    "committees"
  ].find(Boolean);

  return <Navigate to={`${base}/${firstTab ?? "section"}`} replace />;
}
